import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import tagModel from '@/models/tag/tag-list'
import store from '@/store'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import { onBeforeMount, reactive, watch } from '@vue/composition-api'
import useModal from "@/@core/components/base-modal/hooks/useModal";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useTagsList() {
  const { getPermissionModule } = usePermissionByAccount()
  const { openModal, closeModal } = useModal();

  const { fetchTableTagList, removeTag } = tagModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const loading = reactive({
    tableData: false,
  })

  const { resolveDate, resolveTime } = useFlatPickr()
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'tag', label: 'Tag Name', sortable: true },
    { key: 'tag_ref', label: 'Reference' },
    { key: 'string_val', label: 'String Value' },
    { key: 'int_val', label: 'Int Value' },
    { key: 'decimal_val', label: 'Decimal Value' },
    { key: 'bool_val', label: 'Bool Value' },
    { key: 'latest_update', label: 'Latest Update', sortable: true },
    { key: 'actions', label: '' },
  ]

  const tagsListTable = reactive({
    payload: [],
  })

  const fetchTagsList = () => {
    loading.tableData = true
    fetchTableTagList.payload.Page = pagination.currentPage
    fetchTableTagList.payload.Limit = pagination.perPage
    fetchTableTagList.payload.Filters = filters
    fetchTableTagList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchTableTagList)
      .then(response => {
        const respData = response.data
        tagsListTable.payload = respData.tag_list
        pagination.rows = respData.tag_list.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  const onRemoveTag = item => {
    openWarningModal(null, `ต้องการลบรายการ ${item.tag} นี้หรือไม่ ?`, () => {
      loading.tableData = true
      removeTag.payload.Tag = item.tag
      store
        .dispatch('api/apiRequest', removeTag)
        .then(response => {
          openSuccessModal(
            'ลบรายการสำเร็จ !',
            null,
            'ตกลง',
            () => {
              fetchTagsList()
            },
            () => {},
          )
        })
        .catch(error => {
          openDefaultErrorModal(error)
        })
        .finally(() => {
          loading.tableData = false
        })
    })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchTagsList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchTagsList()
    },
    { deep: true },
  )

  onBeforeMount(() => {
    fetchTagsList()
  })

  return {
    fields,
    loading,
    tagsListTable,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    resolveDate,
    resolveTime,
    onRemoveTag,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
    getPermissionModule
  }
}
